import { render, staticRenderFns } from "./customerReceiveList.vue?vue&type=template&id=85082204&scoped=true&"
import script from "./customerReceiveList.vue?vue&type=script&lang=js&"
export * from "./customerReceiveList.vue?vue&type=script&lang=js&"
import style0 from "./customerReceiveList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customerReceiveList.vue?vue&type=style&index=1&id=85082204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85082204",
  null
  
)

export default component.exports